/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Ad_LabelInputs */



/**
* | output |
* | --- |
* | "AD audio track" |
*
* @param {Audio_Embed_Export_Ad_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_ad_label = /** @type {((inputs?: Audio_Embed_Export_Ad_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Ad_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Piste audio publicitaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Audiospur")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traccia audio AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиодорожка AD")
	if (locale === "es") return /** @type {LocalizedString} */ ("pista de audio AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AD 音频轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("広告音声トラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विज्ञापन ऑडियो ट्रैक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faixa de áudio AD")
	return /** @type {LocalizedString} */ ("AD audio track")
});